import React, { useState, useEffect } from 'react';
import { TextField, InputAdornment, CircularProgress } from '@mui/material';

const SubDomainField = ({ subdomain, setSubdomain, finalTheme }) => {
  const [debouncedSubdomain, setDebouncedSubdomain] = useState(subdomain);
  const [isAnalyzing, setIsAnalyzing] = useState(false);

  const handleSubdomainChange = (event) => {
    const rawValue = event.target.value;
    const cleanValue = rawValue.replace(/[^a-z0-9-]/g, '');
    setSubdomain(cleanValue);
    setIsAnalyzing(true);
  };

  useEffect(() => {
    if (subdomain) {
      const handler = setTimeout(() => {
        setDebouncedSubdomain(subdomain);
        setIsAnalyzing(false);
      }, 3000);

      return () => clearTimeout(handler);
    }
  }, [subdomain]);

  useEffect(() => {
    if (debouncedSubdomain) {
      // console.log(`Debounced Subdomain for analysis: ${debouncedSubdomain}`);
      setIsAnalyzing(false);
    }
  }, [debouncedSubdomain]);

  return (
    <TextField
      fullWidth
      label="Subdomain"
      name="subdomain"
      value={subdomain}
      onChange={handleSubdomainChange}
      InputProps={{
        startAdornment: <InputAdornment position="start">https://</InputAdornment>,
        endAdornment: (
          <InputAdornment position="end">
            .dietid.com
            {isAnalyzing && (
              <CircularProgress
                size={16}
                sx={{ marginLeft: 1 }}
              />
            )}
          </InputAdornment>
        ),
      }}
      placeholder="Enter your subdomain"
      margin="normal"
      variant="outlined"
      sx={{ '& .MuiOutlinedInput-root': { borderRadius: `${finalTheme.palette.border.radius} !important` } }}
    />
  );
};

export default SubDomainField;
